<style>
.resources-page-template .avatar-icon > i {
  color: #fff;
}
</style>
<template>
   <!-- <app-layout class="resources-page-template"> -->
   <div class="resources-page-template">
      <Row type="flex" justify="center">
         <Col :span="24">
            <Card :bordered="false" :style="{borderRadius: '0', borderTop: '0px solid #F2F2F2', padding: '10px 0'}" :padding="0">
                  <div @click="openPostSelection">
                     <!-- <Icon type="chevron-right" style="float:right;margin-top:3px"></Icon> -->
                     <Avatar icon="edit" class="avatar-icon" style="background:#333;vertical-align:middle;"></Avatar> &nbsp; Post Update
                  </div>
            </Card>
         </Col>
         <Col :span="24" v-if="false">
            <Card :bordered="false" :style="{borderRadius: '0', borderTop: '0px solid #F2F2F2', padding: '10px 0'}" :padding="0">
              <router-link tag="div" to="/nearby?tab=latest">
                <Icon type="chevron-right" style="float:right;margin-top:3px"></Icon>
                Find Others
              </router-link>
            </Card>
         </Col>
         <Col :span="24">
            <Card :bordered="false" :style="{borderRadius: '0', borderTop: '0px solid #F2F2F2', padding: '10px 0'}" :padding="0">
              <router-link tag="div" :to="'/donate?rid=' + groupID.donate">
                <!-- <Icon type="chevron-right" style="float:right;margin-top:3px"></Icon> -->
                <Avatar icon="heart" class="avatar-icon" style="background:#333;vertical-align:middle;"></Avatar> &nbsp; Donate
              </router-link>
            </Card>
         </Col>
         <Col :span="24">
            <Card :bordered="false" :style="{borderRadius: '0', borderTop: '0px solid #F2F2F2', padding: '10px 0'}" :padding="0">
              <!-- <router-link tag="div" to="/post-update/ABB34DB5-53DE-A3FA-46B1-19835B3FD47C"> -->
                <!-- <Icon type="chevron-right" style="float:right;margin-top:3px"></Icon> -->
              <div v-on:click="reRouteUrl(groupID.report_concern, 'concern')">
                <Avatar :src="bullhorn" class="avatar-icon" style="background:#333;vertical-align:middle;"></Avatar> &nbsp; Report Concern
              </div>
              <!-- </router-link> -->
            </Card>
         </Col>
         <Col :span="24">
            <Card :bordered="false" :style="{borderRadius: '0', borderTop: '0px solid #F2F2F2', padding: '10px 0'}" :padding="0">
              <!-- <div v-on:click="reRouteUrl(Cons[0].GROUP_ID.report_concern, 'suggestion')"> -->
              <div v-on:click="showReportModal('suggestion')">
                <Avatar icon="ios-box" class="avatar-icon" style="background:#333;vertical-align:middle;"></Avatar> &nbsp; Suggestion Box
              </div>
              <!-- <router-link tag="div" to="/post-update/37C6481F-A257-A7A4-E01B-E7B2CA09D9F2">
                <Avatar icon="ios-box" class="avatar-icon" style="background:#333;vertical-align:middle;"></Avatar> &nbsp; Suggestion Box
              </router-link> -->
            </Card>
         </Col>
         <Col :span="24">
            <Card :bordered="false" :style="{borderRadius: '0', borderTop: '0px solid #F2F2F2', padding: '10px 0'}" :padding="0">
              <!-- <div v-on:click="reRouteUrl(Cons[0].GROUP_ID.report_concern, 'hero')"> -->
              <div v-on:click="showReportModal('hero')">
                <Avatar icon="ios-body" class="avatar-icon" style="background:#333;vertical-align:middle;"></Avatar> &nbsp; Report a Hero
              </div>
            </Card>
         </Col>
         <Col :span="24">
            <Card :bordered="false" :style="{borderRadius: '0', borderTop: '0px solid #F2F2F2', padding: '10px 0'}" :padding="0">
              <!-- <router-link tag="div" to="/share"> -->
              <!-- </router-link> -->
              <div @click="showInvite = true">
                <!-- <Icon type="chevron-right" style="float:right;margin-top:3px"></Icon> -->
                <Avatar icon="android-share-alt" class="avatar-icon" style="background:#333;vertical-align:middle;"></Avatar> &nbsp; Invite others to join
              </div>
            </Card>
         </Col>
      </Row>

      <PostUpdateModalComponent v-on:emitProceed="onProceed"></PostUpdateModalComponent>
      <PostUpdateComponent></PostUpdateComponent>

      <!-- <ModalHolder :title="'Share'" :closable="false" m-top="0" :is-show="showShare">
        <template slot="mcontent">
          <div class="modal-container">
              <p style="display:none;" ><a id="sendViaSMS" href="sms:?&body=OFW Watch is a great app. Check it out. https://bit.ly/2HXd9bZ">https://bit.ly/2HXd9bZ</a></p>
              <p style="display:none;" ><a id="sendViaMail" href="mailto:?subject=Share OFW Watch app&body=OFW Watch is a great app. Check it out. https://bit.ly/2HXd9bZ"></a></p>
              <br>
              <Button v-if="ifMobile" @click="sendSMS" long>SMS</Button>
              <Button v-else @click="sendMail" long>Email</Button>
          </div>
        </template>
        <template slot="mfooter">
            <Button @click="showShare = false" long style="margin-top:10px">Close</Button>
        </template>
      </ModalHolder> -->
      <Modal v-model="showInvite"
        class="shareModal"
        title="Invite others to join"
        :closable="false"
        :scrollable="true"
        :transfer="true"
        :mask-closable="false"
        @on-visible-change="onInviteVisibleChange">
        <div slot="header" class="flex-container direction-row center" style="justify-content:space-between;">
          <div class="order-1"></div>
          <b class="order-2">Invite others to join</b>
          <div class="order-3"></div>
          <img alt=" " @click="showInvite=false" style="height:25px; width:25px;position:absolute;top:0;right:0;margin:10px 10px 0 0;" src="@/assets/close.png">
        </div>
        <div v-if="showInvite" style="height:100%;overflow:visible;overflow-y:visible">
          <share-component ref="shareComponent"></share-component>
        </div>
        <div slot="footer">
          <Button type="text" @click="showInvite = false">Close</Button>
        </div>
      </Modal>

      <ModalHolder :title="'REPORT'" m-top="0" m-height="15vh" :is-show="showReportWarning">
        <template slot="mheader">
          <p>Report</p>
        </template>
        <template slot="mcontent">
          <p>
            <!-- For any matters that need immediate response, may it be a problem
            in your community or any fraud related activities, you can send your
            concerns here. -->
          </p>
        </template>
        <template slot="mfooter">
            <Button type="text" @click="showReportWarning = false">Cancel</Button>
            <Button type="primary" v-on:click="routeToReport" >Continue</Button>
        </template>
      </ModalHolder>

      <ReportModalComponent :type="reportType" v-if="reportType" @closeModal="reportType = null"></ReportModalComponent>
   </div>
</template>

<script>
import PostUpdateModalComponent from '@/components/PostUpdateModalComponent'
import ReportModalComponent from '@/components/ReportModalComponent'
import PostUpdateComponent from '@/views/PostUpdateComponent'
import ShareComponent from '@/views/ShareComponent'
import ModalHolder from '@/components/ModalHolderComponent'
import Utils from "@/utils.js";
import $ from "jquery";
import {Message} from 'iview'

export default {
  name: 'ResourcesComponent',
  data () {
    return {
      showReportWarning: false,
      reportType: null,
      groupID: Cons[0].GROUP_ID
    }
  },
  components: {
    PostUpdateModalComponent,
    ModalHolder,
    ShareComponent,
    PostUpdateComponent,
    ReportModalComponent
  },
  computed: {
    profileInfo: {
      get () {
        return this.$store.state.user.info
      }
    },
    ifMobile: {
      get() {
        return Utils.checkMobileOS()=="iOS" ||
               Utils.checkMobileOS()=="Android";
      }
    },
    bullhorn: {
      get() {
        return require('@/assets/bullhorn.png')
      }
    },
    showSuccess: {
      get() {
        return this.$store.state.share.showSuccess
      }
    },
    showInvite: {
      get() {
        return this.$store.state.share.showInvite
      },
      set(v) {
        if ( navigator.onLine )
          this.$store.commit('share/setShowInvite', v)
        else {
          this.$store.commit('share/setShowInvite', false)
          this.$store.commit('hitOffline')
        }
      }
    },
  },
  methods: {
    sendMail() {
      $("#sendViaMail")[0].click();
    },
    sendSMS() {
      $("#sendViaSMS")[0].click();
    },
    onShare() {
      if(this.profileInfo.user_type === 'guest') {
        this.$store.commit('hitCheckpoint');
        return false;
      }
      this.showInvite = true
    },
    openPostSelection () {
      if ( navigator.onLine ) {
        if(this.profileInfo.user_type === 'guest') {
          this.$store.commit('hitCheckpoint');
          return false;
        }
        this.$store.dispatch('menu/getPermittedPlan', null).then((res) => {
          if(res.data.length > 0){
            this.$store.commit('menu/setPostSelectionModal', true)
          }else{
            this.onProceed('journal')
          }
        });
      } else {
        this.$store.commit('hitOffline')
        }
    },
    onProceed (data) {
      if (data != 'journal') {
        let careplanId = data.id
        this.$store.commit('menu/setPostSelectionModal', false)
        this.$store.commit('menu/setTriggerPostSelection', true)
        this.$router.push({
          // path: '/post-update/' + data.id ,
          query: { post: data.id }
        })

        this.$store.commit('publicModule/setShowPostItemModal', true)
      } else {
        this.$store.commit('menu/setPostSelectionModal', false)
        // this.$store.commit('menu/setTriggerPostSelection', true)
        this.$router.push({
          // path: '/post-update/' + this.profileInfo.careplan_id,
          query: { post: this.profileInfo.careplan_id }
        })

        this.$store.commit('publicModule/setShowPostItemModal', true)
      }
    },
    reRouteUrl(id, type) {
      if ( navigator.onLine ) {
      this.$router.push({ query: { post: id, type: type }})
      this.$store.commit('menu/setPostSelectionModal', false)
      this.$store.dispatch('feed/getCareplanInfo', this.$route.query.post).then(res => {
        this.$store.commit('publicModule/setShowPostItemModal', true)
      })
      } else {
        this.$store.commit('hitOffline')
        }
    },
    routeToReport() {
      this.showReportWarning = false;
      this.$router.push({path: '/post-update/' + Cons[0].GROUP_ID.report_concern})
    },
    onInviteVisibleChange(isVisible) {
      if (isVisible) {
        if (this.showSuccess) {
          this.$store.commit('share/setShowSuccess', false);
        }
      } else {
        this.$refs.shareComponent.resetFields();
      }
    },
    showReportModal(type) {
      if ( navigator.onLine ) {
        this.reportType = type
        console.log(type)
        this.$store.commit('menu/setShowWizardModalComponent', true)
      } else {
       this.$store.commit('hitOffline')

      }
    }
  }
}
</script>
